export enum FiLinkToType {
    WebAddress = 1,
    Document = 2,
    UserProfile = 3,
    Media = 4,
    CheckList = 5,
    Email = 6,
    Form = 7,
    ChecklistV2 = 8,
    ChecklistV2Audit = 9,
    PhoneNumber = 10,
}
